import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import "./BundlePackage.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useUserAuth } from "../../context/UserAuthContext";
import CustomSelect from "./../customSelect/CustomSelect";
import dayjs from "dayjs";
import { MdDelete } from "react-icons/md";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Modal from "react-bootstrap/Modal";
import { templates } from "./preWrites";
import axios from "axios";
import CreatableSelect from "react-select/creatable";
import {
  packageIncludesOptions,
  tandcOptions,
  addOnsOption,
  eventTypeOptions,
  unpluggedEventTypes,
  unpluggedOption,
  packageThemeOption,
} from "./packageOptions";
import {
  Grid,
  IconButton,
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  CardActionArea,
  Stack,
} from "@mui/material";
import {
  LocationCity as VenueIcon,
  Nature as LawnIcon,
  MeetingRoom as BanquetIcon,
  Pool as PoolIcon,
  Hotel as RoomIcon,
  Palette as DecorIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";

const EditBundlePackage = () => {
  const [content, setContent] = useState("");
  const { user, language, CityNameFinder, token, currency } = useUserAuth();
  const { id: packageId } = useParams();
  const merchant_id = user.uid;
  const [shortDescription, setShortDescription] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [merchant, setMerchant] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  // Form state
  const [formData, setFormData] = useState({
    package_name: "",
    price: "",
    packs: "",
    room: "",
    venue_id: "",
    city_id: "",
    validity: dayjs(new Date()).format("YYYY-MM-DD"),
    food_type: "",
    eventTypeSlug: "",
    package_theme: "hindu",
    unplugged_category: "",
    checkout: "",
  });

  const calculateDayPointsTotal = (dayPoints) => {
    return dayPoints.reduce((total, point) => {
      const price = parseFloat(point.price) || 0;
      return total + price;
    }, 0);
  };

  const calculateEventPointsTotal = (eventPoint, eventType) => {
    if (!eventPoint || !eventPoint[eventType]) return 0;
    return eventPoint[eventType].reduce((total, point) => {
      const price = parseFloat(point.price) || 0;
      return total + price;
    }, 0);
  };

  const [packageIncOptions, setPackageIncOptions] = useState(
    packageIncludesOptions,
  );
  const [packages, setPackages] = useState([]);
  const handlePackageOptCreate = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setPackageIncOptions((prev) => [...prev, newOption]);
    setPackages((prev) => [...prev, newOption]);
  };
  function packageIncludesHandler(e) {
    setPackages(e || []);
  }

  const [addOnsOpt, setAddOnsOpt] = useState(addOnsOption);
  const [addOns, setAddOns] = useState([]);

  function addOnsHandler(e) {
    setAddOns(e);
  }

  const handleAddonOptCreate = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setAddOnsOpt((prev) => [...prev, newOption]);
    setAddOns((prev) => [...prev, newOption]);
  };

  const [termsOptions, setTermsOptions] = useState(tandcOptions);
  const [t_c, setT_C] = useState([]);
  function termHandler(e) {
    setT_C(e);
  }

  const handleTermOptCreate = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setTermsOptions((prev) => [...prev, newOption]);
    setT_C((prev) => [...prev, newOption]);
  };

  const [days, setDays] = useState([]);
  const [selectedEvents, setSelectedEvents] = useState([]);

  // Data options
  const [venueOptions, setVenueOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pkgCatOptions, setPkgCatOptions] = useState([]);
  const [userData, setUserData] = useState({
    business_name: "",
    city: "",
  });

  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;

  const getNotificationMessage = (notificationKey, templates, data) => {
    const templateObj = templates.find(
      (template) => template.key === notificationKey,
    );
    if (!templateObj) return false;

    let notificationText = templateObj.template;
    for (const key in data) {
      notificationText = notificationText.replace(
        new RegExp(`{{${key}}}`, "g"),
        data[key],
      );
    }
    return { message: notificationText };
  };

  const fetchCityName = async (cityId) => {
    try {
      return await CityNameFinder(cityId);
    } catch (error) {
      console.error("Error fetching city name:", error);
      return "";
    }
  };
  const convertDaysPrice = (days, currencyValue) => {
    return days.map((day) => ({
      ...day,

      dayPoints:
        day.dayPoints?.map((dp) => ({
          ...dp,
          price: Math.floor(dp.price * currencyValue),
        })) || [],
      eventPoint: Object.fromEntries(
        Object.entries(day.eventPoint || {}).map(([key, arr]) => [
          key,
          arr.map((item) => ({
            ...item,
            price: Math.floor(item.price * currencyValue),
          })),
        ]),
      ),
    }));
  };

  const MAX_IMAGES_PER_TAG = 10;
  const [newImages, setNewImages] = useState([]);
  const [tagImages, setTagImages] = useState([]);
  const mapTags = {
    venue_overview: "Venue Overview",
    lawn: "Lawn",
    banquet_hall: "Banquet Hall",
    swimming_pool: "Swimming Pool",
    rooms: "Rooms",
    decorations: "Decorations",
  };

  const tags = [
    {
      id: "venue_overview",
      name: language === "en" ? "Venue Overview" : "वेन्यू अवलोकन",
      icon: <VenueIcon sx={{ fontSize: 32 }} />,
      bgColor: "#f5f7fa",
    },
    {
      id: "lawn",
      name: language === "en" ? "Lawn" : "लॉन",
      icon: <LawnIcon sx={{ fontSize: 32 }} />,
      bgColor: "#f0f9f0",
    },
    {
      id: "banquet_hall",
      name: language === "en" ? "Banquet Hall" : "बैंकेट हॉल",
      icon: <BanquetIcon sx={{ fontSize: 32 }} />,
      bgColor: "#fff8f0",
    },
    {
      id: "swimming_pool",
      name: language === "en" ? "Swimming Pool" : "स्विमिंग पूल",
      icon: <PoolIcon sx={{ fontSize: 32 }} />,
      bgColor: "#f0f9fc",
    },
    {
      id: "rooms",
      name: language === "en" ? "Rooms" : "कमरे",
      icon: <RoomIcon sx={{ fontSize: 32 }} />,
      bgColor: "#f9f0fc",
    },
    {
      id: "decorations",
      name: language === "en" ? "Decorations" : "सजावट",
      icon: <DecorIcon sx={{ fontSize: 32 }} />,
      bgColor: "#fcf0f5",
    },
  ];

  // const groupImagesByTag = (images = []) => {
  //   return images.reduce((acc, img) => {
  //     if (!acc[img.tag_name]) {
  //       acc[img.tag_name] = [];
  //     }
  //     acc[img.tag_name].push(img);
  //     return acc;
  //   }, {});
  // };

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const merchantRes = await axios.get(
          `${base_url}/api/v1/users/id/${merchant_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        const res = merchantRes.data.data;
        setMerchant(res);
        const cityName = await fetchCityName(res.city_id);
        setUserData({
          business_name: res?.business_name,
          city: cityName,
        });
        const packageRes = await axios.get(
          `${base_url}/api/v1/packages/edit/${packageId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        const packageData = packageRes.data.data;
        console.log("package data", packageData);
        setFormData({
          package_name: packageData.package_name,
          price: Math.floor(packageData?.price * currency.value),
          packs: packageData.packs,
          room: packageData.room,
          package_theme: packageData.package_theme,
          unplugged_category: packageData.unplugged_event_type,
          venue_id: packageData.venue_id,
          city_id: packageData.city_id,
          validity: packageData.validity,
          food_type: packageData.food_type,
          eventTypeSlug: packageData.eventtypeslug,
          checkout: packageData.checkout,
        });
        setShortDescription(packageData.shortdescription);
        setContent(packageData.description);
        setPackages(packageData.packageincludes);
        setAddOns(packageData.addons);
        setT_C(packageData.t_c);
        const currencyValue = currency.value;
        const updatedDays = convertDaysPrice(packageData.days, currencyValue);
        setDays(updatedDays);
        // const grouped = groupImagesByTag(packageData?.bundle_package_images);
        setTagImages(packageData?.bundle_package_images);
        const allSelectedEvents = packageData?.days.flatMap(
          (day) => day.eventTypes || [],
        );
        setSelectedEvents(allSelectedEvents);
        const makeAuthenticatedRequest = (url) => {
          return axios.get(url, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
        };
        const [venuesRes, citiesRes, categoriesRes] = await Promise.all([
          makeAuthenticatedRequest(`${base_url}/api/v1/venues`),
          makeAuthenticatedRequest(`${base_url}/api/v1/cities`),
          makeAuthenticatedRequest(
            `${base_url}/api/v1/vendors/package-categories`,
          ),
        ]);
        setVenueOptions(
          venuesRes.data.data.map((v) => ({
            key: v.id,
            value: `${v.business_name} (${v.city_name})`,
          })),
        );
        setCityOptions(
          citiesRes.data.data.map((c) => ({
            key: c.id,
            value: c.name,
            state_id: c.state_id,
          })),
        );
        setPkgCatOptions(categoriesRes.data.data);
      } catch (error) {
        console.error("Error fetching initial data:", error.message);
        toast.error("Failed to load package data");
      }
    };

    if (merchant_id && packageId) fetchInitialData();
  }, [merchant_id, packageId, token, currency]);

  const [selectedVenue, setSelectedVenue] = useState(null);
  useEffect(() => {
    if (!formData.venue_id) return;
    const getCurrentVenueDetails = async () => {
      try {
        const merchantRes = await axios.get(
          `${base_url}/api/v1/users/id/${formData.venue_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        const res = merchantRes.data.data;
        setSelectedVenue(res);
      } catch (error) {
        console.log("venue details getting error", error.messgae);
      }
    };
    getCurrentVenueDetails();
  }, [formData.venue_id, merchant_id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
 

  const handleImageUpload = (e, tagId) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const validFiles = [];
    const errors = [];

    const checkImages = files.map((file) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
          const { width, height } = img;
          URL.revokeObjectURL(img.src);

          const isLandscapeValid = width >= 1024 && height >= 683;
          const isPortraitValid = width >= 683 && height >= 1024;

          if (isLandscapeValid || isPortraitValid) {
            validFiles.push(file);
          } else {
            errors.push(
              `${file.name} must be at least 1024x683 (landscape) or 683x1024 (portrait). Current: ${width}x${height}`,
            );
          }
          resolve();
        };

        img.onerror = () => {
          errors.push(`${file.name} is not a valid image`);
          resolve();
        };
      });
    });

    Promise.all(checkImages).then(() => {
      if (errors.length) {
        toast.error(errors.join("\n"));
      }
      if (validFiles.length > 0) {
        setNewImages((prev) => {
          const existing = prev[tagId] || [];

          if (existing.length + validFiles.length > MAX_IMAGES_PER_TAG) {
            toast.warning("Max 10 images allowed per category");
            return prev;
          }

          return {
            ...prev,
            [tagId]: [...existing, ...validFiles],
          };
        });
      }
    });

    e.target.value = "";
  };
  const removeImage = (tagId, index) => {
    setNewImages((prev) => ({
      ...prev,
      [tagId]: prev[tagId].filter((_, i) => i !== index),
    }));
  };

  const hasAtLeastOneImage = Object.values(tagImages).some(
    (arr) => arr && arr.length > 0,
  );

  const removeExistingImage = async (imageId, index) => {
    try {
      await axios.delete(`${base_url}/api/v1/packages/image/${imageId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setTagImages((prev) => prev.filter((img) => img.id !== imageId));

      toast.success("Image removed successfully");
    } catch (error) {
      console.error("Error removing image:", error);
      toast.error("Failed to remove image");
    }
  };

  const addNewDay = () => {
    setDays((prev) => [
      ...prev,
      {
        id: Date.now(),
        eventTypes: [],
        eventPoint: {},
        dayPoints: [],
      },
    ]);
  };

  const removeDay = (dayId) => {
    const dayToRemove = days.find((d) => d.id === dayId);
    const updatedSelectedEvents = selectedEvents.filter(
      (event) => !dayToRemove.eventTypes.includes(event),
    );

    setSelectedEvents(updatedSelectedEvents);
    setDays(days.filter((d) => d.id !== dayId));
  };

  const handleDayEventChange = (dayId, selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((opt) => opt.value)
      : [];

    setDays(
      days.map((day) =>
        day.id === dayId ? { ...day, eventTypes: selectedValues } : day,
      ),
    );

    // Update selected events across all days
    const allSelected = days.flatMap((day) =>
      day.id === dayId ? selectedValues : day.eventTypes,
    );
    setSelectedEvents(allSelected);
  };

  const addEventPoint = (dayId, eventType) => {
    setDays(
      days.map((day) =>
        day.id === dayId
          ? {
              ...day,
              eventPoint: {
                ...day.eventPoint,
                [eventType]: [
                  ...(day.eventPoint[eventType] || []),
                  { id: Date.now(), value: "", price: "" },
                ],
              },
            }
          : day,
      ),
    );
  };

  const updateEventPoint = (dayId, eventType, pointId, field, value) => {
    setDays(
      days.map((day) =>
        day.id === dayId
          ? {
              ...day,
              eventPoint: {
                ...day.eventPoint,
                [eventType]: day.eventPoint[eventType].map((point) =>
                  point.id === pointId ? { ...point, [field]: value } : point,
                ),
              },
            }
          : day,
      ),
    );
  };

  const removeEventPoint = (dayId, eventType, pointId) => {
    setDays(
      days.map((day) =>
        day.id === dayId
          ? {
              ...day,
              eventPoint: {
                ...day.eventPoint,
                [eventType]: day.eventPoint[eventType].filter(
                  (p) => p.id !== pointId,
                ),
              },
            }
          : day,
      ),
    );
  };

  const addDayPoint = (dayId) => {
    setDays(
      days.map((day) =>
        day.id === dayId
          ? {
              ...day,
              dayPoints: [
                ...day.dayPoints,
                { id: Date.now(), value: "", price: "" },
              ],
            }
          : day,
      ),
    );
  };

  const updateDayPoint = (dayId, pointId, field, value) => {
    setDays(
      days.map((day) =>
        day.id === dayId
          ? {
              ...day,
              dayPoints: day.dayPoints.map((point) =>
                point.id === pointId ? { ...point, [field]: value } : point,
              ),
            }
          : day,
      ),
    );
  };

  const removeDayPoint = (dayId, pointId) => {
    setDays(
      days.map((day) =>
        day.id === dayId
          ? {
              ...day,
              dayPoints: day.dayPoints.filter((p) => p.id !== pointId),
            }
          : day,
      ),
    );
  };

  // Validation
  const validateForm = () => {
    if (!formData.package_name.trim()) {
      toast.error("Package name is required");
      return false;
    }

    if (
      !formData.price ||
      isNaN(formData.price) ||
      Number(formData.price) <= 0
    ) {
      toast.error("Please enter a valid price");
      return false;
    }

    if (!shortDescription.trim()) {
      toast.error("Short description is required");
      return false;
    }

    if (!formData.validity) {
      toast.error("Validity date is required");
      return false;
    }

    return true;
  };

  const getTotalImagesCount = () => {
    const oldCount = Number(tagImages?.length)

    const newCount = Object.values(newImages || {}).reduce(
      (total, arr) => total + (arr?.length || 0),
      0,
    );

    return oldCount + newCount;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const totalImages = getTotalImagesCount();
    if (totalImages < 4) {
      toast.error(`Minimum 4 images required. Currently: ${totalImages}`);
      return;
    }

    if (!validateForm()) return;

    setIsSubmitting(true);
    const filtered_price = Math.floor(formData.price * currency.country_value);
    const finalDays = convertDaysPrice(days, currency.country_value);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("package_name", formData.package_name);
      formDataToSend.append("eventTypeSlug", formData.eventTypeSlug || "other");
      formDataToSend.append("price", filtered_price.toString());
      formDataToSend.append("food_type", formData.food_type || "");
      formDataToSend.append("shortDescription", shortDescription);
      formDataToSend.append("venue_id", formData.venue_id || merchant_id);
      formDataToSend.append(
        "city_id",
        formData.city_id || merchant?.city_id || "",
      );
      formDataToSend.append("validity", formData.validity);
      formDataToSend.append("packs", formData.packs || "");
      formDataToSend.append("room", formData.room || "");
      formDataToSend.append("checkout", formData.checkout || "");
      formDataToSend.append("description", content);
      formDataToSend.append("package_theme", formData.package_theme);
      formDataToSend.append(
        "unplugged_event_type",
        formData.unplugged_category,
      );

      // Stringify and append array fields
      formDataToSend.append("days", JSON.stringify(finalDays || []));
      formDataToSend.append("t_c", JSON.stringify(t_c || []));
      formDataToSend.append("packageIncludes", JSON.stringify(packages || []));
      formDataToSend.append("addOns", JSON.stringify(addOns || []));
      formDataToSend.append("packagestatus", false);
      formDataToSend.append("state_id", selectedVenue?.state_id);
      formDataToSend.append("country_id", selectedVenue?.country_id);
      formDataToSend.append("updated_by", merchant_id);

      Object.entries(newImages).forEach(([tagName, images]) => {
        images.forEach((file) => {
          formDataToSend.append("images", file);
          formDataToSend.append("tag_name", tagName);
        });
      });
      const response = await axios.put(
        `${base_url}/api/v1/packages/update/${packageId}`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log("response data", response.data);
      if (response.status === 200) {
        toast.success("Package updated successfully!");
        navigate("/dashboard/bundle-package");
      }
    } catch (error) {
      console.error("Package update error:", error);
      toast.error(error.response?.data?.message || "Failed to update package");
    } finally {
      setIsSubmitting(false);
    }
  };

  const getAvailableEventTypes = () => {
  // Unplugged package
  if (formData.unplugged_category) {
    return (
      unpluggedEventTypes[formData.unplugged_category]?.filter(
        (option) => !selectedEvents.includes(option.value)
      ) || []
    );
  }

  // Categories without package theme
  if (
    [
      "birthday-package",
      "engagement-package",
      "honeymoon-package",
      "anniversery-package",
    ].includes(formData.eventTypeSlug)
  ) {
    return (
      eventTypeOptions[formData.eventTypeSlug]?.filter(
        (option) => !selectedEvents.includes(option.value)
      ) || []
    );
  }

  // Normal package theme based
  return (
    eventTypeOptions[formData.package_theme]?.filter(
      (option) => !selectedEvents.includes(option.value)
    ) || []
  );
};

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div
                className="card-header d-flex justify-content-between align-items-center text-white"
                style={{ backgroundColor: "#085f9a" }}
              >
                <h4>
                  {language === "en"
                    ? "Update Bundle Package"
                    : "बंडल पैकेज अपडेट करें"}
                </h4>
                <Link to="/dashboard/bundle-package">
                  <button className="btn btn-light">All Packages</button>
                </Link>
              </div>

              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  {/* Package Name */}
                  <div className="form-group">
                    <label className="control-label col-form-label">
                      {language === "en" ? "Package Name" : "बंडल पैकेज का नाम"}{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      name="package_name"
                      placeholder="Enter Package Name"
                      type="text"
                      className="form-control"
                      value={formData.package_name}
                      onChange={handleInputChange}
                      required
                      maxLength={100}
                    />
                  </div>

                  {/* Venue-specific fields */}
                  {(merchant?.sub_category_id == "t5CjPhRmhZAgJ5ZxXKlQ" ||
                    merchant?.sub_category_id == "UyZXebMRha8pT62o7NFX") && (
                    <>
                      <div className="form-group">
                        <CustomSelect
                          title="Select Venue"
                          placeholder="Enter Venue Name"
                          name="venue_id"
                          data={venueOptions}
                          defaultValue={formData?.venue_id}
                          onChange={(value) =>
                            handleSelectChange("venue_id", value)
                          }
                          isRequired={true}
                        />
                      </div>
                      <div className="form-group">
                        <CustomSelect
                          title="Select City"
                          placeholder="Enter City"
                          name="city_id"
                          data={cityOptions}
                          defaultValue={formData?.city_id}
                          onChange={(value) =>
                            handleSelectChange("city_id", value)
                          }
                          isRequired={true}
                        />
                      </div>
                    </>
                  )}

                  {/* Package Category */}
                  <div className="form-group">
                    <label>
                      Package Category <span className="text-danger">*</span>
                    </label>
                    <select
                      name="eventTypeSlug"
                      value={formData.eventTypeSlug}
                      className="form-select"
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Category</option>
                      {pkgCatOptions.map((item) => (
                        <option key={item.id} value={item.cat_slug}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {![
                    "unplugged-package",
                    "birthday-package",
                    "engagement-package",
                    "honeymoon-package",
                    "anniversery-package",
                  ].includes(formData.eventTypeSlug) && (
                    <div className="form-group">
                      <label>
                        {language === "en"
                          ? "Package Theme"
                          : "पैकेज थीम का चुनाव करें"}
                        <span className="text-danger">*</span>
                      </label>
                      <select
                        name="package_theme"
                        value={formData?.package_theme}
                        className="form-select"
                        onChange={(e) => {
                          handleInputChange(e);
                          setDays((prevDays) =>
                            prevDays.map((day) => ({
                              ...day,
                              eventTypes: [],
                            })),
                          );
                          setSelectedEvents([]);
                        }}
                        required
                      >
                        <option value="">Select Package Theme</option>
                        {packageThemeOption?.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {formData.eventTypeSlug === "unplugged-package" && (
                    <div className="form-group">
                      <label>
                        {language === "en"
                          ? "Unplugged Category"
                          : " अनप्लग की केटेगरी का चुनाव करें"}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <select
                        name="unplugged_category"
                        value={formData.unplugged_category}
                        className="form-select"
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Select Unplugged Category</option>
                        {unpluggedOption.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {/* Package Details */}
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label>
                        No of Pax <span className="text-danger">*</span>
                      </label>
                      <input
                        name="packs"
                        type="number"
                        placeholder="No of pax"
                        className="form-control"
                        value={formData.packs}
                        onChange={handleInputChange}
                        onWheel={(e) => e.currentTarget.blur()}
                        min="1"
                        max="9999"
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group">
                      <label>
                        No of Rooms <span className="text-danger">*</span>
                      </label>
                      <input
                        name="room"
                        type="number"
                        placeholder="No of rooms"
                        className="form-control"
                        value={formData.room}
                        onChange={handleInputChange}
                        min="0"
                        max="9999"
                        required
                      />
                    </div>
                  </div>

                  {/* Menu Type */}
                  <div className="form-group">
                    <label>
                      Menu Type <span className="text-danger">*</span>
                    </label>
                    <select
                      name="food_type"
                      className="form-select"
                      value={formData.food_type}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select</option>
                      <option value="Veg Food">Veg Food</option>
                      <option value="Non Veg">Non Veg</option>
                      <option value="Mix Menu">Mix Menu</option>
                    </select>
                  </div>
                  {/* Package Includes */}
                  <div className="form-group">
                    <label>
                      Package Includes <span className="text-danger">*</span>
                    </label>
                    <CreatableSelect
                      closeMenuOnSelect={false}
                      isMulti
                      options={packageIncOptions}
                      selected={true}
                      value={packages}
                      onChange={packageIncludesHandler}
                      onCreateOption={handlePackageOptCreate}
                    />
                  </div>

                  {/* Short Description */}
                  <div className="form-group">
                    <label>
                      Short Description <span className="text-danger">*</span>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm ms-2"
                        onClick={() => setShowModal(true)}
                      >
                        AI Generated
                      </button>
                    </label>
                    <textarea
                      placeholder="Description..."
                      className="form-control"
                      rows={3}
                      value={shortDescription}
                      onChange={(e) => setShortDescription(e.target.value)}
                      required
                    />
                  </div>

                  {/* Day-wise Package Details */}
                  <div className="my-3">
                    <button
                      type="button"
                      className="btn btn-primary mb-3"
                      onClick={addNewDay}
                    >
                      Add Day Wise Details
                    </button>

                    {days.map((day, dayIndex) => {
                      const dayPointsTotal = calculateDayPointsTotal(
                        day.dayPoints || [],
                      );
                      return (
                        <div key={day.id} className="card mb-3">
                          <div className="card-header d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">Day {dayIndex + 1}</h5>
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => removeDay(day.id)}
                            >
                              Remove Day
                            </button>
                          </div>

                          <div className="card-body">
                            {/* Day Points */}
                            <div className="mb-3">
                              <button
                                type="button"
                                className="btn btn-secondary btn-sm mb-2"
                                onClick={() => addDayPoint(day.id)}
                              >
                                Add Day Wise Point
                              </button>

                              {day?.dayPoints?.map((point) => (
                                <div key={point.id} className="row g-2 mb-2">
                                  <div className="col-md-8">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Point description"
                                      value={point.value}
                                      onChange={(e) =>
                                        updateDayPoint(
                                          day?.id,
                                          point?.id,
                                          "value",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </div>

                                  <div className="col-md-3">
                                    <div className="input-group ">
                                      <div className="input-group-prepend">
                                        <div className="input-group-text">
                                          {currency?.symbol}
                                        </div>
                                      </div>
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Price"
                                        onWheel={(e) => e.currentTarget.blur()}
                                        value={point.price}
                                        onChange={(e) =>
                                          updateDayPoint(
                                            day.id,
                                            point.id,
                                            "price",
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-1">
                                    <button
                                      type="button"
                                      className="btn btn-danger"
                                      onClick={() =>
                                        removeDayPoint(day.id, point.id)
                                      }
                                    >
                                      <MdDelete />
                                    </button>
                                  </div>
                                </div>
                              ))}
                              <div className="text-end mx-1 my-2">
                                <strong>
                                  Day Points Total: ₹
                                  {dayPointsTotal?.toFixed(2)}
                                </strong>
                              </div>
                            </div>
                            {/* <div className="form-group mb-3">
                              <label>Event Types</label>
                              <Select
                                isMulti
                                options={getAvailableEventTypes()}
                                value={day.eventTypes.map((type) => ({
                                  value: type,
                                  label: type,
                                }))}
                                onChange={(selected) =>
                                  handleDayEventChange(day.id, selected)
                                }
                                className="basic-multi-select"
                                classNamePrefix="select"
                              />
                            </div> */}

                            <div className="form-group mb-3">
                              <label>Event Types</label>
                              <Select
                                isMulti
                                placeholder="Select event types"
                                options={getAvailableEventTypes()}
                                value={day.eventTypes.map((type) => ({
                                  value: type,
                                  label: type,
                                }))}
                                onChange={(selected) =>
                                  handleDayEventChange(day.id, selected)
                                }
                                className="basic-multi-select"
                                classNamePrefix="select"
                              />
                              {/* {![
                                "unplugged-package",
                                "birthday-package",
                                "engagement-package",
                                "honeymoon-package",
                                "anniversery-package",
                              ].includes(formData.eventTypeSlug) && (
                                <small className="text-danger mt-1 ">
                                  Please select package theme first
                                </small>
                              )} */}
                              {/* {!formData.package_theme && (
                                <small className="text-danger mt-1 ">
                                  Please select package theme first
                                </small>
                              )} */}
                            </div>
                            {/* Event Points */}
                            {day.eventTypes.map((eventType) => {
                              const eventTotal = calculateEventPointsTotal(
                                day.eventPoint,
                                eventType,
                              );
                              return (
                                <div key={eventType} className="mb-3">
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h6>{eventType} Details</h6>
                                    <button
                                      type="button"
                                      className="btn btn-success btn-sm text-white"
                                      onClick={() =>
                                        addEventPoint(day.id, eventType)
                                      }
                                    >
                                      Add {eventType} Point
                                    </button>
                                  </div>

                                  {(day.eventPoint[eventType] || []).map(
                                    (point) => (
                                      <div
                                        key={point.id}
                                        className="row g-2 mb-2"
                                      >
                                        <div className="col-md-8">
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder={`${eventType} detail`}
                                            value={point.value}
                                            onChange={(e) =>
                                              updateEventPoint(
                                                day.id,
                                                eventType,
                                                point.id,
                                                "value",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                        <div className="col-md-3">
                                          <div className="input-group ">
                                            <div className="input-group-prepend">
                                              <div className="input-group-text">
                                                {currency?.symbol}
                                              </div>
                                            </div>
                                            <input
                                              type="number"
                                              className="form-control"
                                              placeholder="Price"
                                              onWheel={(e) =>
                                                e.currentTarget.blur()
                                              }
                                              value={point.price}
                                              onChange={(e) =>
                                                updateEventPoint(
                                                  day.id,
                                                  eventType,
                                                  point.id,
                                                  "price",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-1">
                                          <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() =>
                                              removeEventPoint(
                                                day.id,
                                                eventType,
                                                point.id,
                                              )
                                            }
                                          >
                                            <MdDelete />
                                          </button>
                                        </div>
                                      </div>
                                    ),
                                  )}
                                  <center>
                                    {" "}
                                    <span className="mt-4 my-5">
                                      <strong>
                                        Total: {eventType} Price ₹
                                        {eventTotal?.toFixed(2)}
                                      </strong>
                                    </span>
                                  </center>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {/* Price */}
                  <div className="form-group">
                    <label>
                      Package Price <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">
                        {currency.symbol}
                      </span>
                      <input
                        name="price"
                        type="number"
                        placeholder="Package Price"
                        className="form-control"
                        onWheel={(e) => e.currentTarget.blur()}
                        value={formData.price}
                        onChange={handleInputChange}
                        required
                        min="0"
                        step="0.01"
                      />
                    </div>
                  </div>

                  {/* Description */}
                  <div className="form-group">
                    <label>Description (Package Includes)</label>
                    <ReactQuill
                      theme="snow"
                      value={content}
                      onChange={setContent}
                      placeholder="Describe your package details..."
                      className="editor-input"
                    />
                  </div>

                  {/* Add-ons */}
                  <div className="form-group">
                    <label>Add-ons (Optional)</label>
                    <CreatableSelect
                      closeMenuOnSelect={false}
                      isMulti
                      options={addOnsOpt}
                      value={addOns}
                      selected={true}
                      onChange={addOnsHandler}
                      onCreateOption={handleAddonOptCreate}
                    />
                  </div>

                  {/* Terms & Conditions */}
                  <div className="form-group">
                    <label>Terms & Conditions (Optional)</label>
                    <CreatableSelect
                      closeMenuOnSelect={false}
                      isMulti
                      options={termsOptions}
                      value={t_c}
                      selected={true}
                      onChange={termHandler}
                      onCreateOption={handleTermOptCreate}
                    />
                  </div>

                  {/* Validity */}
                  <div className="form-group">
                    <label>
                      Offer Valid Till <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="validity"
                      value={dayjs(formData.validity).format("YYYY-MM-DD")}
                      onChange={handleInputChange}
                      min={dayjs().format("YYYY-MM-DD")}
                      max={dayjs().add(1, "year").format("YYYY-MM-DD")}
                      required
                    />
                  </div>

                  <Grid container spacing={3} sx={{ mt: 2, mb: 2 }}>
                    <Grid item xs={12}>
                      <Typography fontWeight={600} sx={{ mb: 2 }}>
                        Existing Package Images
                      </Typography>
                      <Grid container spacing={2}>
                        {tagImages?.map((image, index) => (
                          <Grid item xs={6} sm={4} md={2} key={index}>
                            <Box sx={{ position: "relative" }}>
                              <img
                                src={image.desktop_image}
                                alt=""
                                style={{
                                  width: "100%",
                                  height: 100,
                                  objectFit: "cover",
                                  borderRadius: 8,
                                }}
                              />
                              <Typography
                                sx={{
                                  position: "absolute",
                                  bgcolor: "white",
                                  top: -1,
                                  left: -1,
                                  padding: "0px 5px",
                                  borderLeft: "0.5px solid #ccc",
                                  borderTop: "0.5px solid #ccc",
                                  fontSize: "12px",
                                }}
                              >
                                {mapTags[image.tag_name]}
                              </Typography>
                              <Typography
                                sx={{
                                  position: "absolute",
                                  bgcolor:image.status ? 'green' :'red',
                                  color:'white',
                                  borderRadius:'0 10px 0 0',
                                  // top: 20,
                                  left: -1,
                                  bottom: 0,
                                  padding: "0px 5px",
                                  fontSize: "12px",
                                }}
                              >
                                {image.status ? 'Active' :'Review'}
                              </Typography>
                              <IconButton
                                size="small"
                                color="error"
                                sx={{
                                  position: "absolute",
                                  top: -8,
                                  right: -8,
                                  bgcolor: "white",
                                }}
                                onClick={() =>
                                  removeExistingImage(image.id, index)
                                }
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography fontWeight={600}>
                        Upload New Package Images
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Upload at least one image (max 10 per category)
                      </Typography>
                    </Grid>

                    {tags.map((tag) => (
                      <Grid item xs={6} sm={4} md={2} key={tag.id}>
                        <Card
                          sx={{
                            border: "1px solid",
                            borderColor: "divider",
                            "&:hover": { borderColor: "primary.main" },
                            cursor: "pointer",
                          }}
                        >
                          <CardActionArea
                            onClick={() =>
                              document
                                .getElementById(`upload-${tag.id}`)
                                .click()
                            }
                            sx={{ height: "100%" }}
                          >
                            <CardContent>
                              <Stack spacing={1} alignItems="center">
                                <input
                                  type="file"
                                  hidden
                                  multiple
                                  accept="image/*"
                                  id={`upload-${tag.id}`}
                                  onChange={(e) => handleImageUpload(e, tag.id)}
                                />

                                <Avatar
                                  sx={{
                                    bgcolor: "#ccc",
                                    width: 48,
                                    height: 48,
                                  }}
                                >
                                  {tag.icon}
                                </Avatar>

                                <Typography
                                  fontSize={14}
                                  fontWeight={600}
                                  align="center"
                                >
                                  {tag.name}
                                </Typography>

                                <Typography
                                  fontSize={12}
                                  color="text.secondary"
                                  align="center"
                                >
                                  {language === "en"
                                    ? `Upload ${tag.name.toLowerCase()} images`
                                    : `${tag.name} की तस्वीरें`}
                                </Typography>
                              </Stack>
                            </CardContent>
                          </CardActionArea>
                        </Card>
                      </Grid>
                    ))}

                    {tags.map((tag) =>
                      newImages[tag.id]?.length ? (
                        <Grid item xs={12} key={`${tag.id}-preview`}>
                          <Typography fontWeight={600} sx={{ mb: 1 }}>
                            {tag.name}
                          </Typography>

                          <Grid container spacing={2}>
                            {newImages[tag.id].map((image, index) => (
                              <Grid item xs={6} sm={4} md={2} key={index}>
                                <Box sx={{ position: "relative" }}>
                                  <img
                                    src={URL.createObjectURL(image)}
                                    alt=""
                                    style={{
                                      width: "100%",
                                      height: 125,
                                      objectFit: "cover",
                                      borderRadius: 8,
                                    }}
                                  />
                                  <IconButton
                                    size="small"
                                    color="error"
                                    sx={{
                                      position: "absolute",
                                      top: -8,
                                      right: -8,
                                      bgcolor: "white",
                                    }}
                                    onClick={() => removeImage(tag.id, index)}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                        </Grid>
                      ) : null,
                    )}
                  </Grid>
                  <button
                    type="submit"
                    className="btn btn-primary bundlebutton"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Updating..." : "Update Package"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* AI Generated Description Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>AI Generated Descriptions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {templates
            .filter(
              (item) =>
                !formData.eventTypeSlug ||
                item?.category === formData.eventTypeSlug,
            )
            .map((item) => (
              <div
                key={item.key}
                className="p-2 mb-2 border rounded cursor-pointer hover-bg-light"
                onClick={() => {
                  const result = getNotificationMessage(item.key, templates, {
                    package_name: formData.package_name,
                    price: formData.price,
                    business_name:
                      merchant?.category_id === "trvwyuvRqNTuZQh8KNbi"
                        ? merchant?.business_name
                        : selectedVenue?.business_name,
                    city:
                      cityOptions.find((c) => c.key === formData.city_id)
                        ?.value ||
                      selectedVenue?.city ||
                      "the city",
                  });
                  if (result) {
                    setShortDescription(result.message);
                  }
                  setShowModal(false);
                }}
              >
                {item.template}
              </div>
            ))}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EditBundlePackage;
